export default __webpack_public_path__ + "static/media/helmet1.e3e93243.png";